



























import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import OverlayWindow from "../general/OverlayWindow.vue";
import Loading from "../general/Loading.vue";

export default Vue.extend({
  name: "ListMailAddresses",
  components: {
    OverlayWindow,
    Loading,
  },
  props: {
    mailAddresses: Array,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      detailsTitle: "Liste der E-Mail Adressen",
    };
  },
  created() {},
  mounted() {},
  methods: {
    closeDetails() {
      this.$emit("closeOverlay");
    },
  },

  watch: {},

  computed: {},
});
